var map = {
	"./add_col_after.svg": "6400",
	"./add_col_before.svg": "0383",
	"./add_row_after.svg": "3f49",
	"./add_row_before.svg": "4b75",
	"./bold.svg": "ff26",
	"./checklist.svg": "f589",
	"./code.svg": "100a",
	"./combine_cells.svg": "350c",
	"./delete_col.svg": "ff5a",
	"./delete_row.svg": "5ce0",
	"./delete_table.svg": "e93a",
	"./github.svg": "14f6",
	"./hr.svg": "3eaa",
	"./image.svg": "931c",
	"./italic.svg": "9944",
	"./link.svg": "40a1",
	"./mention.svg": "6d35",
	"./ol.svg": "2127",
	"./paragraph.svg": "bb80",
	"./quote.svg": "1636",
	"./redo.svg": "63dc",
	"./remove.svg": "5088",
	"./strike.svg": "8984",
	"./table.svg": "979b",
	"./ul.svg": "6775",
	"./underline.svg": "f893",
	"./undo.svg": "34b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";